import { useEffect, useState } from 'react';
import { REACT_APP_MONOLITH_BASE_URL } from 'runtimeEnvVars';

import { apiGet } from 'utils/axios';

export interface ComplianceRequirement {
  uuid: string;
  name: string;
}

interface ComplianceRequirementsResponse {
  data: {
    requirements?: ComplianceRequirement[];
  };
}

let catalogPromise: Promise<ComplianceRequirement[]> | null = null;

const fetchComplianceRequirements = (): Promise<ComplianceRequirement[]> => {
  if (!catalogPromise) {
    catalogPromise = apiGet(
      `${REACT_APP_MONOLITH_BASE_URL}/internal_api/compliance_requirements`,
    )
      .then(
        (response: ComplianceRequirementsResponse) =>
          response.data.requirements ?? [],
      )
      .catch(() => {
        catalogPromise = null;
        return [];
      });
  }
  return catalogPromise;
};

export const resetComplianceRequirementsCacheForTests = () => {
  catalogPromise = null;
};

export function useComplianceRequirements(): {
  requirements: ComplianceRequirement[];
  loading: boolean;
} {
  const [requirements, setRequirements] = useState<ComplianceRequirement[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    void fetchComplianceRequirements().then(catalog => {
      if (mounted) {
        setRequirements(catalog);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { requirements, loading };
}
